// extracted by mini-css-extract-plugin
export default {"root":"classes_root__4ayqF","left":"classes_left__MSsrb","title-container":"classes_title-container__uPd1d","right":"classes_right__V6FmH"};